import React, { useState } from 'react';
import UniversalModal from './UniversalModal';
import CargoManagementModal from './CargoManagementModal';
import CargoHoldView from './CargoHoldView';
import CargoTab from './InfoPanelTabs/CargoTab';

/**
 * Trade & Economy Screen
 * Consolidates: Cargo Hold and Ship Resources
 */
const TradeScreen = ({ onClose, location, embedded = false }) => {
  const [activeTab, setActiveTab] = useState('resources');

  const tabs = [
    { id: 'resources', label: 'Ship Resources', icon: '🛢️' },
    { id: 'cargo', label: 'Life Support', icon: '📦' },
    { id: 'trade', label: 'Trade Goods', icon: '💰' }
  ];

  const content = (
    <>
      {activeTab === 'resources' && (
        <div className="tab-content">
          <CargoTab />
        </div>
      )}
      
      {activeTab === 'cargo' && (
        <div className="tab-content">
          <CargoManagementModal onClose={() => {}} embedded={true} />
        </div>
      )}

      {activeTab === 'trade' && (
        <div className="tab-content">
          <CargoHoldView />
        </div>
      )}
    </>
  );

  if (embedded) {
    return (
      <div className="trade-screen-embedded">
        <div className="embedded-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`embedded-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span>{tab.icon}</span> {tab.label}
            </button>
          ))}
        </div>
        {content}
      </div>
    );
  }

  return (
    <UniversalModal
      title="CARGO & RESOURCES"
      subtitle="Cargo Management & Ship Resources"
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      onClose={onClose}
      className="trade-screen"
    >
      {content}
    </UniversalModal>
  );
};

export default TradeScreen;
